<template>
    <section class="container-fluid position-relative overflow-hidden lead">
        <chrome-welcome-navbar/>
        <div class="row">
            <div class="col-md-12 col-lg-3 col-xl-3 col-xxl-1 container">
                <div class="position-absolute">
                    <div v-show="count==0">
                <span class="z-index-n1 position-absolute mt-n1 ml-n1">
                <InlineSvg :src="require('@/assets/images/chrome-welcome/1.svg')"/>
              </span>
                        <h2 class="col-md-4 col-lg-4 col-xl-5 col-xxl-4 h2 ms-3 mt-5 text-white an-fade an-fast">
                            <br>WOOHOO!</h2>
                        <p class="col-md-4 col-lg-4 col-xl-5 col-xxl-4 ms-3 text-white mt-5 pb-md-8 pb-lg-11 pb-xl-13
                          fs-6 an-fade an-fast">
                            You're about to start saving tons of money and get the best deals on all your favorite
                            products! <br>
                        </p>
                    </div>
                    <div v-show="count==1">
                <span class="z-index-n1 position-absolute mt-n1 ml-n1">
                    <InlineSvg :src="require('@/assets/images/chrome-welcome/2.svg')"/>
                </span>
                        <h2 class="col-md-4 col-lg-4 col-xl-5 col-xxl-4 h2 ms-3 mt-5  text-white an-fade an-fast">
                            <br>Shop as usual</h2>
                        <p class="col-md-4 col-lg-4 col-xl-5 col-xxl-4 ms-3 text-white mt-5 pb-md-8 pb-lg-11 pb-xl-13
                         fs-6 an-fade an-fast">
                            Just shop on Amazon like normal while RebateKey will automatically find, highlight, and
                            apply
                            the best rebates for you. <br>
                        </p>
                    </div>
                    <div v-show="count==2">
                <span class="z-index-n1 position-absolute mt-n1 ml-n1">
                  <InlineSvg :src="require('@/assets/images/chrome-welcome/3.svg')"/>
                </span>
                        <h2 class="col-md-4 col-lg-4 col-xl-5 col-xxl-4 h2 ms-3 mt-5  text-white  an-fade an-fast">
                            <br>Grab your deal</h2>
                        <p class="col-md-4 col-lg-4 col-xl-5 col-xxl-4 ms-3 text-white mt-5  pb-md-1 pb-lg-11 pb-xl-13
                         pb-xxl-6 fs-6 an-fade an-fast">
                            It's just one click to earn cashback! We'll also hold your purchases for an hour to make
                            sure
                            no one else gets your deal.
                        </p>
                    </div>
                    <div v-show="count==3">
                <span class="z-index-n1 position-absolute mt-n1 ml-n1">
                  <InlineSvg :src="require('@/assets/images/chrome-welcome/4.svg')"/>
                </span>
                        <h2 class="col-md-4 col-lg-4 col-xl-5 h2 ms-3 mt-5 text-white an-fade an-fast">
                            <br>Claim your discount
                        </h2>
                        <p class="col-md-4 col-lg-4 col-xl-5 col-xxl-4 ms-3 text-white mt-5 pb-md-1 pb-lg-5 pb-xl-6
                        fs-6 an-fade an-fast">
                            After checking out on Amazon, we'll
                            automatically apply the biggest savings and reward you with cash.
                        </p>
                    </div>
                    <div v-show="count==4">
                <span class="z-index-n1 position-absolute mt-n1 ml-n1 pb-5">
                  <InlineSvg :src="require('@/assets/images/chrome-welcome/5.svg')"/>
                </span>
                        <h2 class="col-md-4 col-lg-4 col-xl-4 h2 ms-3 mt-5 text-white  an-fade an-fast">
                            <br>Boost your savings
                        </h2>
                        <p class="col-md-4 col-lg-3 col-xl-4 col-xxl-3 ms-3 text-white mt-5 pb-md-1 pb-lg-0 pb-xl-2
                        pb-xxl-2 fs-6 an-fade an-fast">
                            Earn even more money with the RebateKey
                            affiliate program. Just distribute your affiliate link and receive as much as you can earn.
                        </p>
                    </div>
                    <div class="mt-4 d-flex justify-content-start  position-absolute z-index-2">
                        <div class="d-inline-block d-flex align-items-center">
                            <a v-on:click="count=0;" class="rounded-circle ms-4"
                               :class="{'bg-white-dots' : !count, 'bg-off' : count,}" type="button">1</a>
                        </div>
                        <div class="d-inline-block d-flex align-items-center">
                            <a v-on:click="count=1; " class="rounded-circle ms-4"
                               :class="{'bg-white-dots' : count==1, 'bg-off' : count!=1}" type="button">2</a>
                        </div>
                        <div class="d-inline-block d-flex align-items-center">
                            <a v-on:click="count=2; " class="rounded-circle ms-4"
                               :class="{'bg-white-dots' : count==2, 'bg-off' : count!=2}" type="button">3</a>
                        </div>
                        <div class="d-inline-block d-flex align-items-center">
                            <a v-on:click="count=3; " class="rounded-circle ms-4"
                               :class="{'bg-white-dots' : count==3, 'bg-off' : count!=3}" type="button">4</a>
                        </div>
                        <div class="d-inline-block d-flex align-items-center">
                            <a v-on:click="count=4; " class="rounded-circle ms-4"
                               :class="{'bg-white-dots' : count==4, 'bg-off' : count!=4}" type="button">5</a>
                        </div>
                    </div>
                    <div class="mt-5 pt-4 position-absolute z-index-1">
                        <a v-if="count<4" v-on:click="handleClick" type="button"
                           class="ms-3 d-flex justify-content-between btn btn-cta btn-size text-white">
                            <b>Next</b>
                            <span>
                    <img src="../assets/images/chrome-welcome/ButtonHexagon.svg" class="w-100 img-fluid" height="740"
                         width="1150" alt="ArrowButton1"/>
                  </span>
                        </a>
                        <div v-if="count==4">
                            <a href="https://rebatekey.com/sign-in"
                               class="ms-3 z-index-1 d-flex justify-content-between btn btn-cta btn-size text-white"
                               role="button">
                                <b>Sign In</b>
                                <span>
                    <img src="../assets/images/chrome-welcome/ButtonHexagon.svg" class="w-100 img-fluid" height="740"
                         width="1150" alt="ArrowButton2"/>
                  </span>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="w-100">
                    <canvas class="position-relative d-none d-xxl-block" style="width: 90px; height: 25rem;"/>
                    <canvas class="position-relative d-none d-xl-block d-xxl-none" style="width: 90px; height: 25rem;"/>
                    <canvas class="position-relative d-none d-lg-block d-xl-none" style="width: 90px; height: 24rem;"/>
                    <canvas class="position-relative d-none d-md-block d-lg-none" style="width: 90px; height: 7rem;"/>
                    <canvas class="position-relative d-none d-sm-block d-md-none" style="width: 90px; height: 4rem;"/>
                    <canvas class="position-relative d-block" style="width: 90px; height: 24rem;"/>
                </div>
            </div>
            <div class="col-md-10 offset-md-1 col-lg-6 col-xl-6 col-xxl-6 d-flex align-items-center">
                <div class="w-100 mt-5 pt-5 pt-xxl-10 mb-5 pb-5 mb-5 pb-xxl-10">
                    <canvas class="d-none d-xxl-block" style="width: 90px; height: 7rem;"/>
                    <div v-show="count==0" :class="{'an-slide-bottom  ' : stateClass, 'an-slide-top' : !stateClass}"
                         class="active an-delay-carousel">
                        <img :src="require('../assets/images/chrome-welcome/1-1.svg')"
                             class="position-absolute z-index-2 top-0 end-0 w-50 mt-md-n9 mt-lg-n7 mt-xl-n8 mt-xxl-n11
                              me-md-9 me-lg-7 me-xl-8 me-xxl-9 an-delay an-fade"
                             alt="InstructionOne"/>
                        <img :src="require('../assets/images/chrome-welcome/sl1.webp')" class="d-block img-fluid w-100"
                             height="740" width="1150" alt="ImageSlide1">
                    </div>
                    <div v-show="count==1" :class="{'an-slide-bottom' : stateClass, 'an-slide-top' : !stateClass}"
                         class=" active an-delay-carousel">
                        <span class="d-flex justify-content-end an-fade w-100">
                        <img :src="require('../assets/images/chrome-welcome/2-1.svg')"
                             class="position-absolute z-index-2 img-fluid mt-xxl-n9 mt-xl-n7 mt-lg-n6 mt-md-n8 me-xxl-8
                             me-xl-9 me-lg-7 me-md-9 an-fade an-delay"
                             height="740"
                             width="1150" alt="InstructionTwo" style="width: 35%;"/>
                        <img :src="require('../assets/images/chrome-welcome/3-1.svg')"
                             class="position-absolute z-index-2 img-fluid bottom-0 mb-xxl-n8 mb-xl-n7 mb-lg-n6 mb-md-n6
                             me-xxl-13 me-xl-12 me-lg-10 me-md-12 an-fade an-delay"
                             height="740"
                             width="1150" alt="InstructionThree" style="width: 30%;"/>
                      </span>
                        <img :src="require('../assets/images/chrome-welcome/sl2.webp')" class="d-block img-fluid w-100"
                             height="1000" width="1466" alt="ImageSlide2">
                    </div>
                    <div v-show="count==2" :class="{'an-slide-bottom' : stateClass, 'an-slide-top' : !stateClass}"
                         class="active an-delay-carousel">
                        <img :src="require('../assets/images/chrome-welcome/sl3.webp')" class="d-block img-fluid w-100"
                             height="1000" width="1466" alt="ImageSlide3">
                        <img :src="require('../assets/images/chrome-welcome/arrow3.svg')"
                             class="position-absolute z-index-2 bottom-0 end-0 an-delay an-fade w-50 img-fluid
                              mb-xxl-n11 me-xxl-10 mb-xl-n10 me-xl-10 mb-lg-n8 me-lg-8 mb-md-n10 me-md-10"
                             height="740" width="1150"
                             alt="InstructionFour"/>
                    </div>
                    <div v-show="count==3" :class="{'an-slide-bottom' : stateClass, 'an-slide-top' : !stateClass}"
                         class="active an-delay-carousel">
                        <img :src="require('../assets/images/chrome-welcome/sl4.1.webp')"
                             class="position-absolute z-index-2 top-0 start-50 translate-middle-x mt-n8 w-75 img-fluid
                              an-delay an-fade"
                             height="760" width="968" alt="ImageSlide4"/>
                        <img :src="require('../assets/images/chrome-welcome/sl4.webp')" class="d-block img-fluid w-100"
                             height="1000" width="1466" alt="InstructionFive">
                    </div>
                    <div v-show="count==4" :class="{'an-slide-bottom' : stateClass, 'an-slide-top' : !stateClass}"
                         class="mt-5 pt-3 mx-auto active w-md-100 w-xl-75 an-delay-carousel">
                        <div class="border shadow-lg rounded-top rounded-bottom"
                             style="width: 100%; display: inline-block; background-color: #323542;">
                            <div class="rounded-top" style="background-color: #FFFFFF; width: 100%">
                                <img class="mt-2 pb-2 mx-5" :src="require('../assets/images/logo.svg')"/>
                            </div>
                            <div class="d-flex justify-content-end"
                                 style="padding: 12px 20px; background: linear-gradient(181deg,#1aa3bc 0,#198faf 100%)">
                                <div class="btn m-x3 text-white" style="background: rgba(15,17,17,.2);">Referral balance
                                </div>
                            </div>
                            <div class="row mx-0 p-4 px-5 " style="background: rgba(255,255,255,.1);">
                                <div class="col-3">
                                    <div class="fw-normal text-white text-center fs-table1">Your referrals
                                    </div>
                                    <div class="mt-2 fs-3 fw-bold d-flex justify-content-center text-white">
                                        <table-counter v-if="count==4" :ini-time="8" :time="500"/>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="fw-normal text-white text-center fs-table1"> Comissions pending
                                    </div>
                                    <div
                                        class="mt-2 fs-3 fw-bold d-flex justify-content-center align-items-end text-white">
                                        $
                                        <table-counter v-if="count==4" :ini-time="25" :time="155"/>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="fw-normal text-white text-center fs-table1">Current referral balance
                                    </div>
                                    <div
                                        class="mt-2 fs-3 fw-bold d-flex justify-content-center align-items-end text-white">
                                        $
                                        <table-counter v-if="count==4" :ini-time="120" :time="32"/>
                                    </div>
                                </div>
                            </div>
                            <div class="row mx-2">
                                <div>
                                    <div class="mt-5 mb-2 fs-6 fc-tablepink"> Share referral link using:</div>
                                </div>
                                <img src="../assets/images/chrome-welcome/SocialMedia.svg"
                                     class="mt-5 mb-2 img-fluid w-100" width="100px" height="auto" alt="SocialMedia"/>
                            </div>
                            <div class="mx-5 mt-5 mb-5">
                                <div class="fs-6 fc-tablepink">How much will I earn ?</div>

                                <table class="table w-100 mt-5">
                                    <tbody class="text-white">
                                    <tr class="mt-4">
                                        <td class="col fs-table2 fw-normal">Rebates paid</td>
                                        <td class="col fc-table"><span>1</span>+</td>
                                        <td class="col fc-table">
                                            <table-counter v-if="count==4" :ini-time="5" :time="800"/>
                                            +
                                        </td>
                                        <td class="col fc-table">
                                            <table-counter v-if="count==4" :ini-time="9" :time="445"/>
                                            +
                                        </td>
                                        <td class="col fc-table"><span>25</span>+</td>
                                        <td class="col fc-table"><span>50</span>+</td>
                                    </tr>
                                    <tr class="mt-4">
                                        <th scope="row" class="fs-table2 fw-normal">Comissions earned</th>
                                        <td class="fc-table">$<span>1</span>
                                        </td>
                                        <td class="fc-table">$<span>2</span>
                                        </td>
                                        <td class="fc-table">$
                                            <table-counter v-if="count==4" :ini-time="3" :time="1300"/>
                                        </td>
                                        <td class="fc-table">$
                                            <table-counter v-if="count==4" :ini-time="5" :time="800"/>
                                        </td>
                                        <td class="fc-table">$
                                            <table-counter v-if="count==4" :ini-time="9" :time="445"/>
                                        </td>
                                    </tr>
                                    <tr class="" style="background: linear-gradient(90deg,#323542 0,#FB528D 100%);">
                                        <th scope="row" class="fs-table2 fw-normal">Total earnings</th>
                                        <td class="fc-table">$<span>1</span>
                                        </td>
                                        <td class="fc-table">$<span>3</span>
                                        </td>
                                        <td class="fc-table">$
                                            <table-counter v-if="count==4" :ini-time="6" :time="666"/>
                                        </td>
                                        <td class="fc-table">$<span>11</span>
                                        </td>
                                        <td class="fc-table">$<span>20</span>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div>
                        <canvas class="position-relative d-none d-md-block d-lg-none"
                                style="width: 90px; height: 7rem;"/>
                    </div>
                </div>
            </div>
            <div class="col-md-1 col-lg-1 col-xl-1 col-xxl-1"></div>
        </div>
    </section>
    <chrome-welcome-footer/>
</template>

<script>
import {defineComponent,} from "vue";
import InlineSvg from "../components/misc/InlineSvg";
import TableCounter from "../components/chrome-welcome/TableCounter";
import ChromeWelcomeNavbar from "../components/chrome-welcome/ChromeWelcomeNavbar";
import ChromeWelcomeFooter from "../components/chrome-welcome/ChromeWelcomeFooter";

export default defineComponent({
    name: "ChromeWelcome",
    data() {
        return {
            count: 0,
            stateClass: true,
        }
    },
    watch: {
        count(val, oldVal) {
            if (val > oldVal) {
                this.stateClass = true;
            } else {
                this.stateClass = false;
            }
        },
    },
    components: {
        InlineSvg,
        TableCounter,
        ChromeWelcomeNavbar,
        ChromeWelcomeFooter
    },
    methods: {
        handleClick() {
            this.count++;
        },
    }
});
</script>

<style scoped lang="scss">
.an-delay {
    animation-delay: 1s;
}

.an-delay-carousel {
    animation-delay: .5s;
}

ul {
    list-style: none;
}

.bg-white-dots {
    height: 10px;
    width: 10px;
    background: rgb(255, 255, 255, 1);
    font-size: 0;
}

.bg-off {
    height: 7px;
    width: 7px;
    background: rgb(255, 255, 255, .2);
    font-size: 0;
}

body {
    padding-top: 0;
}

.fs-table1 {
    font-size: .75rem;
}

.fs-table2 {
    font-size: .75rem;
    width: 10rem;
}

.fc-table {
    color: $white-welcome;
    font-size: .75rem;
    width: 3rem;
}

.fc-tablepink {
    color: $pink-welcome;
}

.btn-cta {
    background-color: $pink;
}

@media (min-width: 576px) {
    .mt-n1 {
        margin-top: -18rem !important;
    }
    .ml-n1 {
        margin-left: -20rem !important;
    }
    .btn-size {
        width: 10rem;
    }
}

@media (min-width: 768px) {
    .mt-n1 {
        margin-top: -21rem !important;
    }
    .ml-n1 {
        margin-left: -31rem !important;
    }
    .btn-size {
        width: 10rem;
    }
}

@media (min-width: 992px) {
    .mt-n1 {
        margin-top: -22rem !important;
    }
    .ml-n1 {
        margin-left: -30rem !important;
    }
    .btn-size {
        width: 10rem
    }
}

@media (min-width: 1200px) {
    .mt-n1 {
        margin-top: -21rem !important;
    }
    .ml-n1 {
        margin-left: -24rem !important;
    }
    .btn-size {
        width: 10rem
    }
}

@media (min-width: 1400px) {
    .mt-n1 {
        margin-top: -19.5rem !important;
    }
    .ml-n1 {
        margin-left: -25rem !important;
    }
    .btn-size {
        width: 15rem;
    }
}
</style>